import GoogleMap from './GoogleMap';
import Marker from './Marker';
import Polyline from './Polyline';

export { Marker, Polyline };
export default GoogleMap;
